<template lang="jade">
  div(style="width: 100%;")
    .row
      .col-md-4
        input.form-control(type="text", placeholder="Filtrar por código", v-model="searchCode")
      .col-md-4
        input.form-control(type="text", placeholder="Filtrar por nome", v-model="searchName")
      .col-md-4
        UniqueSelect(filterText="Filtrar por tipo", useState="statusSheets/searchStatus", :callback="getTypeFilters")
    .row
      .mcl-items(style="max-height: 500px;")
        span.center-element(v-if="loading") Carregando...
        span(v-if="!loading && displayedData.length")
          virtualList(:size="25", :remain="20")
            .checkbox.text-left(v-for="(item, $index) in displayedData", :key="$index")
              .col-md-2 {{ item.employee.code }}
              .col-md-8 {{ item.employee.name }}
              .col-md-2
                router-link(v-if="item.status.uuid", :to="{name: 'sheetChecker', params: {uuid: item.status.uuid}}")
                  | {{ item.status.name }}
                span(v-if="!item.status.uuid") {{ item.status.name }}
</template>

<script>
import virtualList from 'vue-virtual-scroll-list'
import UniqueSelect from '../../../common/UniqueSelect/UniqueSelect.vue'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('statusSheets', ['statesList', 'loading', 'searchStatus']),
    searchCode: {
      get () { return this.$store.getters['statusSheets/search'].code },
      set (newVal) { this.$store.commit('statusSheets/search', {code: newVal}) }
    },
    searchName: {
      get () { return this.$store.getters['statusSheets/search'].name },
      set (newVal) { this.$store.commit('statusSheets/search', {name: newVal}) }
    },
    displayedData () {
      let current = this.statesList
      console.log('this.searchStatus', this.searchStatus.selected)
      if (this.searchStatus.selected && this.searchStatus.selected.id !== 'all') {
        current = current.filter(i => i.status.type === this.searchStatus.selected.id)
      }
      if (this.searchCode !== '') {
        current = current.filter(i => i.employee.code && i.employee.code.includes(this.searchCode))
      }
      if (this.searchName !== '') {
        current = current.filter(i => i.employee.name && i.employee.name.toLowerCase().includes(this.searchName.toLowerCase()))
      }
      return current
    },
    openSheet (uuid) {
      let routeData = this.$router.resolve({name: 'sheetChecker', query: {uuid}})
      window.open(routeData.href, '_blank')
    }
  },
  methods: {
    getTypeFilters () {
      return {body: {success: [
        {id: 'all', name: 'Todos os estágios'},
        {id: 'not_gen', name: 'Não geradas'},
        {id: 'not_scan', name: 'Não escaneadas'},
        {id: 'not_proc', name: 'Não processadas'},
        {id: 'not_verified', name: 'Não verificadas'},
        {id: 'ignored', name: 'Ignoradas'},
        {id: 'verified', name: 'Verificadas'}
      ]}}
    }
  },
  components: {
    UniqueSelect,
    virtualList
  }
}
</script>



// WEBPACK FOOTER //
// StatusSheetsList.vue?0f298bde